import script from "./PolicyRegulations.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyRegulations.vue?vue&type=script&setup=true&lang=js"

import "./PolicyRegulations.vue?vue&type=style&index=0&id=3389e37f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3389e37f"]])

export default __exports__